var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Flag of Portugal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 480,
    fill: "#d80027"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 256,
    height: 480,
    fill: "#006600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256,240) scale(0.7)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFCC00",
    stroke: "#D4A200",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 120,
    ry: 120,
    cx: 0,
    cy: 0,
    fill: "#FFCC00",
    stroke: "#D4A200",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 92,
    ry: 92,
    cx: 0,
    cy: 0,
    fill: "none",
    stroke: "#D4A200",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 54,
    ry: 54,
    cx: 0,
    cy: 0,
    fill: "none",
    stroke: "#D4A200",
    strokeWidth: 4,
    transform: "rotate(25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 54,
    ry: 54,
    cx: 0,
    cy: 0,
    fill: "none",
    stroke: "#D4A200",
    strokeWidth: 4,
    transform: "rotate(-25)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-36,28 C -28,10 -28,-18 0,-28 C 28,-18 28,10 36,28 C 18,38 0,48 0,48 C 0,48 -18,38 -36,28 Z",
    fill: "#d80027",
    stroke: "#c00",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26,22 C -20,8 -20,-14 0,-20 C 20,-14 20,8 26,22 C 12,28 0,36 0,36 C 0,36 -12,28 -26,22 Z",
    fill: "#ffffff",
    stroke: "#c00",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0033A0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -12,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: -12,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 0,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0,
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 6,
    width: 6,
    height: 6,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFCC00",
    transform: "translate(0,12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -48,
    y: -32,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: -32,
    width: 10,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -36,
    y: -36,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: -36,
    width: 4,
    height: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/pt.aec54dfd113e1e5bb862d848f300f223.svg";
export { ForwardRef as ReactComponent };